import { render, staticRenderFns } from "./DiscussionForumDetail.vue?vue&type=template&id=1d80f36e&scoped=true&"
import script from "./DiscussionForumDetail.vue?vue&type=script&lang=js&"
export * from "./DiscussionForumDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d80f36e",
  null
  
)

export default component.exports